function importAll(r) {
  r.keys().forEach(r);
}
importAll(require.context('../../../public/javascripts/backbone/entities/', true, /\.js$/))
importAll(require.context('../../../public/javascripts/backbone/lib/components/', true, /\.js$/))
import "../../../public/vendor/gmaps-markerclusterer-plus/src/markerclusterer.js"
import "../../../public/vendor_modified/magnific_popup/magnific_popup.js"
